// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-radius: 0.25rem;
}

.close {
  margin: 0 10px;
  cursor: pointer;
}

.alert-success {
  color: #009100;
  background-color: #8ce9a0;
  border-color: #7bcf8e;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.alert-info {
  color: #008db8;
  background-color: #b9ebf8;
  border-color: #008db8;
}

.alert-warning {
  color: #e4aa0d;
  background-color: #e6db7d;
  border-color: #c9c06f;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
